// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var MomentRe$ReactHooksTemplate = require("../MomentRe.res.js");

function empty(param) {
  return {
          id: undefined,
          name: "",
          key: "",
          active: false,
          expirationDate: undefined
        };
}

function id(t) {
  return t.id;
}

function key(t) {
  return t.key;
}

function name(t) {
  return t.name;
}

function active(t) {
  return t.active;
}

function expirationDate(t) {
  return t.expirationDate;
}

function setName(t, name) {
  return {
          id: t.id,
          name: name,
          key: t.key,
          active: t.active,
          expirationDate: t.expirationDate
        };
}

function setKey(t, key) {
  return {
          id: t.id,
          name: t.name,
          key: key,
          active: t.active,
          expirationDate: t.expirationDate
        };
}

function setActive(t, active) {
  return {
          id: t.id,
          name: t.name,
          key: t.key,
          active: active,
          expirationDate: t.expirationDate
        };
}

function setExpirationDate(t, expirationDate) {
  return {
          id: t.id,
          name: t.name,
          key: t.key,
          active: t.active,
          expirationDate: expirationDate
        };
}

function convertDateToMoment(date) {
  if (date !== undefined) {
    return Caml_option.some(MomentRe$ReactHooksTemplate.moment(undefined, date));
  }
  
}

function decode(json) {
  return {
          id: Json_decode.field("id", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          name: Json_decode.field("name", Json_decode.string, json),
          key: Json_decode.field("key", Json_decode.string, json),
          active: Json_decode.field("active", Json_decode.bool, json),
          expirationDate: convertDateToMoment(Json_decode.field("expiration_date", (function (param) {
                      return Json_decode.optional(Json_decode.string, param);
                    }), json))
        };
}

function getMomentString(date) {
  if (date !== undefined) {
    return Caml_option.valFromOption(date).format("YYYY-MM-DD HH:mm:SS");
  } else {
    return "";
  }
}

function encode(t) {
  return Json_encode.object_({
              hd: [
                "name",
                t.name
              ],
              tl: {
                hd: [
                  "active",
                  t.active
                ],
                tl: {
                  hd: [
                    "expiration_date",
                    getMomentString(t.expirationDate)
                  ],
                  tl: /* [] */0
                }
              }
            });
}

exports.empty = empty;
exports.id = id;
exports.key = key;
exports.name = name;
exports.active = active;
exports.setActive = setActive;
exports.expirationDate = expirationDate;
exports.setKey = setKey;
exports.setName = setName;
exports.setExpirationDate = setExpirationDate;
exports.decode = decode;
exports.encode = encode;
/* MomentRe-ReactHooksTemplate Not a pure module */
